// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"5ba00dd1","836":"6d2bfabf","843":"97f02394"}[chunkId] + ".chunk.js";
};